<template>
  <div>
    <v-toolbar flat color="white" pt-4 mt-4>
      <v-btn round color="primary" @click="addUserRoleModal=true">Add User Role</v-btn>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :items="userroles"
      item-key="id"
      align-center
      style="cursor: pointer"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">
          <v-icon v-if="!props.item.isAdmin" small @click="deleteItem(props.item)">delete</v-icon>
        </td>
        <td
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        >{{props.item.userGroup.name}}</td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.name}}</td>
        <td
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        >{{props.item.description}}</td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>

    <v-dialog v-model="addUserRoleModal" max-width="750px">
      <v-card flat color="white">
        <v-toolbar color="primary">
          <h1 class="headline white--text">ADD USER ROLE</h1>
        </v-toolbar>
        <v-card-text>
          <v-select
            v-model="item.userGroupId"
            :items="usergroups"
            item-text="name"
            item-value="id"
            label="Associated Group"
          ></v-select>
          <v-text-field label="User Role Name" v-model="item.name"></v-text-field>
          <v-text-field label="Description" v-model="item.description"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" @click="addUserRoleModal=false">Cancel</v-btn>
            <v-btn round color="primary" @click="saveUserRole">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/services/Api";
export default {
  props: ["userroles", "usergroups", "modulesubmodules"],
  data() {
    return {
      addUserRoleModal: false,
      item: {},
      headers: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Group",
          align: "center",
          value: "userGroup.name"
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        }
      ]
    };
  },
  methods: {
    deleteItem(item) {
      confirm("Are you sure you would like to delete this user role?") &&
        Api()
          .put("/userRole/" + item.id, {
            isActive: false,
            isDeleted: true
          })
          .then(this.$emit("userRoleChange"));
    },
    saveUserRole() {
      Api()
        .post("/userRole", {
          name: this.item.name,
          description: this.item.description,
          userGroupId: this.item.userGroupId,
          organisationId: this.$store.state.currentOrg.org.id,
          isActive: true,
          isDelete: false
        })
        .then(async response => {
          let post =[]
          for (let i = 0; i < this.modulesubmodules.length; i++) {
            await post.push({
              organisationId: this.$store.state.currentOrg.org.id,
              moduleSubmoduleId: this.modulesubmodules[i].id,
              userRoleId: response.data.id,
              create: false,
              read: false,
              update: false,
              delete: false,
              admin: false,
              isActive: true,
              isDeleted: false
            })
            
          }
          await Api().post("/routePermission", {
              batch: post
            });

          (this.addUserRoleModal = false),
            (this.item = {}),
            this.$emit("userRoleChange");
        });
    },
    async routerLinkToDetails(item) {
      let url =item
      let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/userRoles/:userRoleId'})
      await this.$store.dispatch('setCurrentRoute', route[0])
      this.$router.push({ path: "/userRoles/" + item.id });
    }
  }
};
</script>

<style>
</style>